import React, { useState, useContext, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { useToast } from '../../../controller/ToastController';
import HotelController, { RoomListType, AreaType } from '../../../controller/HotelController';
import DeviceList from '../../../components/DeviceList';
import { AuthContext } from '../../../navigation/AuthProvider';
import StoreController, { CurrentStoreContext } from '../../../controller/StoreController';

const HotelEditRoomType = (props: any) => {
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const oAuthContext = useContext(AuthContext);
  const user_id = oAuthContext.userInfo.user_id;
  const roomData: RoomListType = props.roomData;
  const [roomName, setRoomName] = useState<string>();
  const [deviceList, setDeviceList] = useState<AreaType[]>();
  const [areaList, setAreaList] = useState<any[]>([]);

  const onChangeRoomName = (e: any) => {
    setRoomName(e.target.value);
  };

  const getDeviceList = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
        user_id: user_id,
      };
      const oRes: any = await HotelController.getDevice(oParams);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data.data;
        setDeviceList(oResponse);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const editRoomType = async () => {
    if (roomName === '') {
      showToast('룸타입 명을 입력해주세요.', 'error');
    } else if (areaList.length === 0) {
      showToast('객실을 선택해주세요.', 'error');
    } else {
      try {
        const params = {
          store_id: currentStore.value,
          area_grade_id: roomData.area_grade_id,
          area_grade_name: roomName,
          area_id: areaList,
        };
        const response = await HotelController.editRoomType(params);
        if (response.data.ok) {
          props.setEditRoom(false);
          props.refresh();
          showToast('객실 정보가 수정되었습니다.')
        } else {
          showToast('다시 시도해주세요.', 'error');
        }
      } catch (err) {
        console.log('err-->', err);
      }
    }
  };
  
  useEffect(() => {
    getDeviceList();
  }, []);
  useEffect(() => {
    setRoomName(roomData.area_grade_name);
  }, [roomData]);

  return (
    <Style>
      <div>
        <div className="mainTitle">
          <h4>객실 그레이드 수정하기</h4>
        </div>
        <div className="title">
          <h4>객실 그레이드 명</h4>
        </div>
        <input
          type="text"
          placeholder="객실 그레이드명을 입력해주세요"
          value={roomName}
          onChange={onChangeRoomName}
        />
        <div className="deviceListWrap">
          <div className="title">
            <h4>객실 선택</h4>
          </div>
          <DeviceList
            deviceList={deviceList}
            setAreaList={setAreaList}
            editingRoom={roomData}
            disableCondition={true}
          />
        </div>
        <button className="submitButton" onClick={editRoomType}>저장하기</button>
      </div>
    </Style>
  );
};

export default HotelEditRoomType;
const Style = styled.div`
  h4 {
    font-size: 18px;
    font-weight: 500;
    color: #555;
  }
  p {
    font-size: 14px;
    font-weight: 500;
    color: #555;
  }

  .mainTitle {
    margin-bottom: 34px;
    padding: 8px 26px;
    border-radius: 5px;
    background: #ecf5f3;
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 11px;
  }

  input {
    width: 100%;
    padding: 10px 29px;
    border-radius: 5px;
    border: 1px solid #cecece;
    font-size: 16px;
    font-weight: 500;
  }
  input::placeholder {
    color: #979797;
    font-weight: 400;
  }
  .deviceListWrap {
    margin-top: 60px;
  }
  /* submitButton */
  .submitButton {
    width: 100%;
    text-align: center;
  }
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0;
  }
  .contentContainer:nth-child(3) {
    border-radius: 0 0 10px 10px;
  }

  .backButton {
    margin: 0 0 30px 0;
    padding: 0;
  }

  /* input설정 */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }

  @media (max-width: 600px) {
    .roomPrice {
      flex-wrap: wrap;
      input,
      .selector {
        min-width: 150px;
        max-width: 150px;
      }
      p {
        white-space: nowrap;
      }
    }
  }
`;
